import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { LoadingScreen } from "@components/ui";
import { PUBLIC_PATHS, USER_PATHS } from "./paths";
import AppShellLayout from "./AppShellLayout";
import BareLayout from "./BareLayout";

const Home = lazy(() => import("@pages/public/Home"));
const Search = lazy(() => import("@pages/public/Search"));
const PropertyDetails = lazy(() => import("@pages/public/PropertyDetails"));
const NotFound = lazy(() => import("@pages/public/NotFound"));
const AddProperty = lazy(() => import("@pages/user/AddProperty"));

/**
 * AppRoutes — the real route tree, deferred from Phase 2 (routing
 * skeleton) and Phase 3 (design system) until MVP pages existed to route
 * to. Every path constant from `paths.js` that has a built page is wired
 * here; paths without a page yet (Favorites, Profile, Chat, Login, Map,
 * Premium, Payment, Admin — pending later Phase 4 work and Phase 5–10)
 * intentionally fall through to the 404 route rather than being wired to
 * a fake placeholder page.
 *
 * `ProtectedRoute` / `AdminRoute` guards are not yet applied to
 * `/add-property` here: Phase 5 (Authentication System) does not exist
 * yet, so wrapping it now would make the page permanently unreachable
 * for demo/testing purposes. This is a deliberate, temporary choice —
 * the guard wrapping will be added back in Phase 5 without changing
 * AddProperty.jsx itself.
 */
export default function AppRoutes() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route element={<AppShellLayout />}>
          <Route path={PUBLIC_PATHS.HOME} element={<Home />} />
          <Route path={PUBLIC_PATHS.SEARCH} element={<Search />} />
        </Route>

        <Route element={<BareLayout />}>
          <Route path={PUBLIC_PATHS.PROPERTY_DETAILS} element={<PropertyDetails />} />
          <Route path={USER_PATHS.ADD_PROPERTY} element={<AddProperty />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
